import { PawPrint } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";

interface Props {
  backgroundDataUrl?: string;
}

export const StoryCzteryLapyUrgent3 = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;

  return (
    <div
      style={{
        width: "1080px",
        height: "1920px",
        fontFamily: "'Nunito', sans-serif",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#1a3a2a",
      }}
    >
      <img
        src={bgImage}
        alt=""
        draggable={false}
        data-export-bg="true"
        loading="eager"
        decoding="sync"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0,
        }}
      />

      {/* Big tag in top safe zone */}
      <div
        style={{
          position: "absolute",
          top: "300px",
          left: "80px",
          zIndex: 3,
          display: "flex",
          flexDirection: "column",
          gap: "14px",
        }}
      >
        <div
          style={{
            background: "#FFFFFF",
            borderRadius: "16px",
            padding: "10px 20px",
            display: "inline-flex",
            alignSelf: "flex-start",
          }}
        >
          <span style={{ fontSize: "24px", fontWeight: 800, color: "#E8763A", letterSpacing: "3px" }}>
            #PILNAPOTRZEBA
          </span>
        </div>
      </div>

      {/* Vertical color block - left */}
      <div
        style={{
          position: "absolute",
          top: "440px",
          left: "0",
          width: "20px",
          bottom: "240px",
          background: "linear-gradient(180deg, #E8763A 0%, #2D5A3D 100%)",
          zIndex: 2,
        }}
      />

      {/* Content stack */}
      <div
        style={{
          position: "absolute",
          top: "440px",
          left: "80px",
          right: "80px",
          bottom: "240px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          zIndex: 2,
        }}
      >
        {/* Top: Quote-style headline */}
        <div>
          <div
            style={{
              fontSize: "180px",
              lineHeight: 0.6,
              color: "#FFD480",
              fontWeight: 800,
              fontFamily: "Georgia, serif",
              marginBottom: "20px",
            }}
          >
            "
          </div>
          <p
            style={{
              fontSize: "72px",
              fontWeight: 800,
              color: "#FFFFFF",
              lineHeight: 1.1,
              margin: 0,
              textShadow: "0 4px 20px rgba(0,0,0,0.5)",
            }}
          >
            Potrzebne pilne wsparcie naszej zbiórki
          </p>
          <p
            style={{
              fontSize: "30px",
              fontWeight: 700,
              color: "#FFD480",
              marginTop: "32px",
              letterSpacing: "1px",
            }}
          >
            - Stowarzyszenie Cztery Łapy
          </p>
        </div>

        {/* Middle: Stats / what's needed */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "20px",
            marginTop: "60px",
          }}
        >
          {[
            { emoji: "🍖", text: "Karma" },
            { emoji: "💊", text: "Leki" },
            { emoji: "🏥", text: "Opieka wet." },
            { emoji: "🛏️", text: "Schronienie" },
          ].map((item) => (
            <div
              key={item.text}
              style={{
                background: "rgba(255,255,255,0.95)",
                borderRadius: "20px",
                padding: "24px 28px",
                display: "flex",
                alignItems: "center",
                gap: "16px",
              }}
            >
              <span style={{ fontSize: "44px" }}>{item.emoji}</span>
              <span style={{ fontSize: "30px", fontWeight: 700, color: "#2D5A3D" }}>{item.text}</span>
            </div>
          ))}
        </div>

        {/* Bottom: shelter footer + CTA */}
        <div
          style={{
            background: "rgba(0,0,0,0.55)",
            backdropFilter: "blur(10px)",
            borderRadius: "28px",
            padding: "32px 36px",
            display: "flex",
            alignItems: "center",
            gap: "24px",
            marginTop: "60px",
          }}
        >
          <div
            style={{
              width: "76px",
              height: "76px",
              borderRadius: "20px",
              background: "#E8763A",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <PawPrint style={{ width: "40px", height: "40px", color: "#FFFFFF" }} />
          </div>
          <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
            <span style={{ fontSize: "22px", fontWeight: 700, color: "#FFD480", letterSpacing: "1px" }}>
              SZCZEGÓŁY ZBIÓRKI
            </span>
            <span style={{ fontSize: "30px", fontWeight: 800, color: "#FFFFFF", marginTop: "4px" }}>
              fb.com/adoptujpsa.olecko
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
